import { Cube } from "../../../state/types";
import { Score } from "../surroundings/StatScores";

const legend = [
  { low: 0, name: "Zeer goed", description: "Zeer stabiele ondergrond", color: "#3C5941" },
  { low: 0.05, name: "Goed", description: "Relatief stabiel", color: "#819470" },

  { low: 0.15, name: "Matig", description: "Zetting is duidelijk aanwezig", color: "#D0D2A6" },
  {
    low: 0.3,
    name: "Slecht",
    description: "Grote zettingen",
    color: "#FBF2C4",
  },
  { low: 0.6, name: "Zeer slecht", description: "Zeer grote inklinking", color: "#D7995E" },
];

export const BearingCapacity = ({ field }: { field: Cube }) => {
  return (
    <Score stats={field.rast} label="Draagkracht" prop="Zetting" legend={legend}>
      (zetting {(100 * field.rast.Zetting).toFixed()} cm)
    </Score>
  );
};
